import React from 'react';
import { Box, keyframes, useTheme } from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useJobsData } from 'src/context/job-context';

const ToggleSwitch = ({ IsHeatMap, setIsHeatMap }) => {
  const { updateToggle } = useJobsData();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const bounceAnimation = keyframes`
    0% { transform: translateX(0); }
    50% { transform: translateX(${isMobile ? '3px' : '10px'}); }
    100% { transform: translateX(0); }
  `;

  const toggleWidth = isMobile ? 70 : 135; 

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: 1,
        transform: isMobile ? 'rotate(90deg)' : 'none',
        transition: 'transform 0.3s ease',
      }}
    >
      <Box
        sx={{
          position: 'relative',
          width: toggleWidth, 
          height: {
            xs: 32,
            sm: 48,
          },
          borderRadius: 24,
          cursor: 'pointer',
          boxShadow: IsHeatMap
            ? '0 0 15px rgba(33, 43, 54, 0.5)' 
            : '0 0 10px rgba(0, 0, 0, 0.15)',
          background: IsHeatMap
            ? 'linear-gradient(to right, #212b36, #161c23)'
            : 'rgba(245, 245, 245, 0.8)',
          transition: 'all 0.3s ease',
          overflow: 'hidden',
        }}
        onClick={() => {
          setIsHeatMap(prev => !prev);
          updateToggle(!IsHeatMap);
        }}
      >
        <Box sx={{ position: 'absolute', inset: 0, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          {IsHeatMap && (
            <Box 
              component="span"
              sx={{
                fontSize: {
                  xs: '0.65rem',
                  sm: '0.775rem',
                },
                fontWeight: 500,
                position: 'absolute',
                left: {
                  xs: '8px',
                  sm: '16px',
                },
                color: 'white',
                letterSpacing: 0.5,
                transform: isMobile ? 'rotate(-90deg)' : 'none',
              }}
            >
              {isMobile ? 'HM' : 'HEAT MAP'}
            </Box>
          )}
          
          {!IsHeatMap && (
            <Box 
              component="span"
              sx={{
                fontSize: {
                  xs: '0.65rem',
                  sm: '0.775rem',
                },
                fontWeight: 500,
                position: 'absolute',
                right: {
                  xs: '8px',
                  sm: '16px',
                },
                color: 'text.secondary',
                transform: isMobile ? 'rotate(-90deg)' : 'none',
              }}
            >
              {isMobile ? 'DEF' : 'DEFAULT'}
            </Box>
          )}
        </Box>

        <Box
          sx={{
            position: 'absolute',
            top: {
              xs: '4px',
              sm: '6px',
            },
            left: {
              xs: '4px',
              sm: '8px',
            },
            height: {
              xs: 24,
              sm: 36,
            },
            width: {
              xs: 24,
              sm: 36,
            },
            borderRadius: '50%',
            bgcolor: 'white',
            boxShadow: IsHeatMap 
              ? '0 0 8px rgba(255, 255, 255, 0.5), 0 1px 3px rgba(0, 0, 0, 0.2)'
              : '0 1px 3px rgba(0, 0, 0, 0.2)',
            transition: 'transform 0.3s ease',
            transform: IsHeatMap 
              ? { xs: 'translateX(42px)', sm: 'translateX(85px)' } 
              : 'translateX(0)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            animation: `${bounceAnimation} 0.3s ease-in-out`,
          }}
        >
          <Box 
            sx={{
              width: {
                xs: 14,
                sm: 16,
              },
              height: {
                xs: 14,
                sm: 16,
              },
              borderRadius: '50%',
              bgcolor: IsHeatMap ? '#212b36' : 'grey.300',
              transform: IsHeatMap ? 'scale(1)' : 'scale(0.75)',
              transition: 'all 0.3s ease'
            }}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default ToggleSwitch;